module.exports = __webpack_public_path__ + "./static/img/icon-3.f96c5b66f9c64a051473881f2cdb3178.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icon-3.png
// module id = ./client/src/assets/img/company/icon-3.png
// module chunks = 0